import React, { useState } from 'react';

import { Box, Button, IconButton, Paper, Stack, Typography } from '@mui/material';
import { FieldArray } from 'formik';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CopyAllIcon from "@mui/icons-material/CopyAll";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import ProductsList from './products_list';
import AddProductsDialog from '../../../../common/warehouse_and_food_partner_order_form/add_products_dialog';

const DestinationsList = ({ form, formik, onlyDelivery }) => {
    const [productClipboard, setProductClipboard] = useState([]);

    const onRemoveDestination = (formik, position) => {
        const destinationsList = [...(formik?.values?.destinationsList || [])];
        const productsList = [...(formik?.values?.productsList || [])];
        const index = destinationsList?.findIndex(destination => destination?.position === position);

        if (index !== -1) {
            const lastIndex = destinationsList?.length - 1;

            destinationsList?.filter(destination => destination?.position > position)
                ?.forEach(destination => {
                    productsList[destination?.position - 1] = productsList[destination?.position] || [];
                    destinationsList[destination?.position - 1] = {
                        ...destination,
                        position: destination?.position - 1
                    };
                });

            destinationsList.splice(lastIndex, 1);
            productsList.splice(lastIndex, 1);

            formik.setFieldValue(`destinationsList`, destinationsList);
            formik.setFieldValue(`productsList`, productsList);
        }
    };

    const copyProductsToClipboard = (formik, index) => {
        setProductClipboard(formik?.values?.productsList[index]?.slice() || [])
    };

    const pasteProductsFromClipboard = (formik, index) => {
        formik.setFieldValue(`productsList.${ index }`, productClipboard.slice());
    };

    return (
        <FieldArray
            name={ `destinationsList` }
            render={ () => (
                <Stack spacing={ 3 }>
                    {
                        formik?.values?.destinationsList?.map((destination, index) => (
                            <Box key={ destination?.position ?? index }
                                 sx={ { display: 'flex', alignItems: 'flex-start', gap: 2 } }>
                                <Paper variant="outlined" sx={ { flexGrow: 1, p: 3, backgroundColor: 'slate.50' } }>
                                    <Box sx={ {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'flex-start',
                                        mb: 3
                                    } }>
                                        <Typography variant="h6" sx={ { fontWeight: 600 } }>
                                            { destination?.name }
                                        </Typography>

                                        <Stack direction="row" spacing={ 2 }>
                                            {
                                                formik?.values?.productsList[index] && formik?.values?.productsList[index].length > 0 &&
                                                <Button
                                                    size="small"
                                                    startIcon={ <CopyAllIcon/> }
                                                    onClick={ () => copyProductsToClipboard(formik, index) }
                                                >
                                                    Kopiuj listę
                                                </Button>
                                            }
                                            {
                                                productClipboard.length > 0 &&
                                                <Button
                                                    size="small"
                                                    startIcon={ <ContentCopyIcon/> }
                                                    onClick={ () => pasteProductsFromClipboard(formik, index) }
                                                >
                                                    Wklej listę
                                                </Button>
                                            }
                                        </Stack>
                                    </Box>

                                    <ProductsList
                                        formik={ formik }
                                        onlyDelivery={ onlyDelivery }
                                        productsListIndex={ index }
                                    />

                                    <Box sx={ { mt: 2 } }>
                                        <AddProductsDialog
                                            foodPartnerId={ form?.foodPartnerId }
                                            formik={ formik }
                                            dateToCalculateExpirationDate={ form?.deliveryDate }
                                            productsListIndex={ index }
                                            onlyDelivery={ onlyDelivery }
                                            sourceWarehouseId={ form?.sourceWarehouseId }
                                        />
                                    </Box>
                                </Paper>

                                <Box sx={ { pt: 2 } }>
                                    <IconButton
                                        onClick={ () => onRemoveDestination(formik, destination?.position) }
                                        title="Usuń lokalizację"
                                    >
                                        <RemoveCircleIcon/>
                                    </IconButton>
                                </Box>
                            </Box>
                        ))
                    }
                </Stack>
            ) }
        />
    );
};

export default DestinationsList;